module.exports = __webpack_public_path__ + "static/scan_to_pay-ec7477f9707e583e2e203dfc87779080.png";